import { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";

function GalleryCarousel() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Auto-load all images from /public/images/gallery
    const count = 20;
    const loadedImages = [];

    for (let i = 1; i <= count; i++) {
      loadedImages.push(`/images/gallery/gallery-${i}.webp`);
    }

    setImages(loadedImages);
  }, []);

  return (
    <Carousel
      data-bs-theme="dark"
      controls={true}
      indicators={true}
      interval={3000} // auto change every 3 sec
      pause={false} // do NOT stop on hover
      fade={true} // smooth fade transition
    >
      {images.map((src, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100"
            src={src}
            alt={`gallery-${index + 1}`}
            style={{
              maxHeight: "650px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default GalleryCarousel;
